import dayjs, { Dayjs } from '@seolens/date-manager';
import { Tag, theme } from 'antd';
import { FC, memo } from 'react';

import { Site } from '@/modules/Sites';

type Props = Pick<Site, 'contentUpdateDate'> & {
  size?: 'small' | 'default';
};

const getColor = (date: Dayjs): { color: string; time: string } => {
  const {
    token: { green, orange, red, yellow },
  } = theme.useToken();
  const now = dayjs();
  const diffDays = now.diff(date, 'day');
  const diffYears = now.diff(date, 'year');

  let color = red;
  if (diffDays < 3) color = green;
  else if (diffDays < 7) color = yellow;
  else if (diffDays < 28) color = orange;

  let time = `${diffDays} дн. назад`;
  if (diffDays === 0) time = 'сьогодні';
  else if (diffYears === 1) time = 'рік назад';
  else if (diffYears > 1) time = `${diffYears} р. назад`;

  return { color, time };
};

export const SiteContentUpdateDateTag: FC<Props> = memo(({ contentUpdateDate, size = 'default' }) => {
  if (!contentUpdateDate) return null;

  const { color, time } = getColor(dayjs(contentUpdateDate));

  return (
    <Tag>
      {size === 'small' ? (
        <span style={{ color }}>{time}</span>
      ) : (
        <>
          Оновлення контенту було&nbsp;<span style={{ color }}>{time}</span>
        </>
      )}
    </Tag>
  );
});
